import UnsubscribeScreen from './UnsubscribeScreen'

export default UnsubscribeScreen



// WEBPACK FOOTER //
// ./src/containers/Unsubscribe/UnsubscribeScreen/index.js